import axios from 'axios'
import { REACT_APP_API } from '../../config'
import { getQueryConfig } from 'src/features/price-policies/constants'

export const getModelsByBrandName = async (params) => {
    let query = ''
    const {carLots, brandNames} = params
    carLots.forEach(id => {
        query = query + 'car_lot_id[]=' + id + '&'
    });

    if (!brandNames) return

    brandNames.forEach(id => {
        query = query + 'brandName[]=' + id + '&'
    })

    query = query.slice(0, -1)

    const queryConfig = getQueryConfig(params)

    const { data } = await axios(
        `${REACT_APP_API}/bonifications/modelsForBonification?${query}&${queryConfig}`
    )
    return data
}